// Mock data and functions for Weight Prescriber Network

export const mockFormSubmission = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock form submission:', formData);
      resolve({
        success: true,
        message: 'Thank you for your enquiry. We will respond within one business day.',
        enquiryId: `ENQ-${Date.now()}`
      });
    }, 1500);
  });
};

export const mockGAEvent = (eventName, params) => {
  console.log('Mock GA4 Event:', eventName, params);
};
